// Guided selling widget button trigger
$(function () {
  $('.guided-selling-widget .btn-guided-selling').on('click', function () {
    var input = $('.guided-selling-widget .input-number');
    var currentVal = parseInt(input.val());
    guidedSellingTrigger(currentVal);
    $('.guided-selling-widget .btn-number').on('click', function () {
      guidedSellingTrigger(currentVal);
    });
    $('.guided-selling-widget .input-number').on('click', function () {
      guidedSellingTrigger(currentVal);
    });
  });

  function guidedSellingTrigger(val) {
    if (val === 0) {
      $('.guided-selling-widget .btn-guided-selling').addClass('disabled');
    } else {
      if (!isNaN(val)) {
        var url = 'https://signup.littlehotelier.com/start/'
        location.href = url + '?r=' + val;
      }
    }
  }
});



// WEBPACK FOOTER //
// ./scripts/routes/guidedSellingWidget.js